import { useState } from 'react';

import {
  OverlayStyled,
  ModalStyled,
  TitleStyled,
  ContentStyled,
  ActionsStyled,
  ButtonStyled,
  LinkStyled,
} from './popup-styled';

type Popup = {
  onAgree: () => void;
  onDisagree: () => void;
};

export default function TermsPopup({ onAgree, onDisagree }: Popup): JSX.Element | null {
  const [visible, setVisible] = useState(true);

  if (!visible) return null;

  return (
    <OverlayStyled>
      <ModalStyled>
        <TitleStyled>Terms & Conditions - KCC Multiplex</TitleStyled>
        <ContentStyled>
          <ul>
            <li>
              Once a purchase is made, it is considered final. We do not offer refunds, exchanges,
              or cancellations.
            </li>
            <li>
              No food or beverage from outside is permitted at the cinema premises. Only items from
              Rancrisp (L2) and Snax (L2 & L4) are permitted.
            </li>
            <li>
              Mobile phones, cameras and all other electronic devices must be switched off/on silent
              mode before you enter any cinema.
            </li>
            <li>Smoking is not permitted anywhere of the KCC Multiplex premises.</li>
            <li>
              Read the full Terms & Conditions here:{' '}
              <LinkStyled
                href="https://kccmultiplex.lk/terms-and-conditions/"
                target="_blank"
                rel="noopener noreferrer">
                Terms & Conditions
              </LinkStyled>
            </li>
          </ul>
        </ContentStyled>
        <ActionsStyled>
          <ButtonStyled
            $variant="disagree"
            className="disagree-btn"
            onClick={() => {
              setVisible(false);
              onDisagree();
            }}>
            Disagree
          </ButtonStyled>
          <ButtonStyled
            $variant="agree"
            className="agree-btn"
            onClick={() => {
              setVisible(false);
              onAgree();
            }}>
            Agree
          </ButtonStyled>
        </ActionsStyled>
      </ModalStyled>
    </OverlayStyled>
  );
}
